import React from "react";
import styles from "./Loading.module.css";

const Loading = () => {
  return (
    <div className="genuis-loading">
      <div className="loading-letters">
        <div className={styles.loadText}>
          <div className={styles.loader}></div>
          <p>Loading</p>
        </div>
      </div>
    </div>
  );
};

export default Loading;
